import React from 'react';

import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {profileCurrentRequestSelector} from '../../../../../redux/selectors/profile';
import {getProfileRequestById, readRequest} from '../../../../../redux/actions/profile';
import {Forms} from '../../../../../shared/models/forms';
import {initialize, reduxForm} from 'redux-form';
import {IStateProps, Form} from './model';

import {useStyles} from '../../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../../shared/theme/helpers';

import CommonView from './view';
import {profileSlice} from '../../../../../redux/reducers/profile';

const TopicFormContent = ({onModalClose, route}: IStateProps) => {
  const request = useSelector(profileCurrentRequestSelector());
  const dispatch = useDispatch();
  const id = route?.params?.id ? +route.params.id : 0;

  useEffect(() => {
    if (!request) {
      dispatch(getProfileRequestById(+id));
    }
  }, [id, request]);

  useEffect(() => {
    if (!request?.id) {
      return;
    }

    dispatch(readRequest(request.id));
  }, [request?.id, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(profileSlice.actions.setCurrentRequest(null));
    };
  }, []);

  useEffect(() => {
    if (request) {
      dispatch(initialize(Forms.showRequest, request));
    }
  }, [request]);

  const styles = useStyles(({theme, mediaOnly, platformOnly}) => {
    return {
      link: {
        marginLeft: 10,
        ...mediaOnly(DeviceSize.desktop, {width: '100%'}, {}),
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
      },
      noResponseText: {
        color: theme.color.labelText,
        ...mediaOnly(
          DeviceSize.desktop,
          {...theme.fonts.h5Light, marginTop: 20},
          {...theme.fonts.bodySmallLight, marginTop: 30, textAlign: 'center'},
        ),
      },
      responseTitleText: {
        ...mediaOnly(DeviceSize.desktop, theme.fonts.h3Light, theme.fonts.body),
        color: theme.color.textColor,
        ...mediaOnly(DeviceSize.desktop, {marginBottom: 17}, {marginBottom: 16}),
      },
      modalContent: {paddingTop: 23, paddingBottom: 20},
      modalTitle: {...theme.fonts.h2, paddingTop: 0, marginTop: -5},
      input: mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.body),
      // @ts-ignore
      wrapContentStyle: {paddingHorizontal: 90, marginBottom: 40, ...platformOnly('web', {overflow: 'auto'})},
      container: {
        ...mediaOnly(
          DeviceSize.desktop,
          {
            display: 'flex',
            flexDirection: 'column',
            width: 754,
            marginBottom: 5,
          },
          {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            backgroundColor: theme.color.grayMenu,
            paddingHorizontal: 35,
            paddingTop: 35,
            marginBottom: 60,
          },
        ),
      },
      linkContainer: {display: 'flex', flexDirection: 'column', width: '100%', color: theme.color.primaryColor},
      linkSubContainer: {
        ...mediaOnly(
          DeviceSize.desktop,
          {
            marginTop: 15,
          },
          {
            marginTop: 10,
          },
        ),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    };
  });

  const props = {onModalClose, request, styles};

  return React.createElement(CommonView, props);
};

export const Topic = reduxForm<Form, IStateProps>({form: Forms.showRequest})(TopicFormContent);
